import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orderHistoryApi } from "@/features/my-order/features/order-history/api";
import { CreateOrderSheetSetInquiryRequest } from "@/features/my-order/features/order-history/types";
import useIdentity from "@/features/ui/hooks/use-identity";
import { companyTypeRequestFormatConverter } from "@/utils/converter";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";
import { AxiosError } from "axios";
import { AGENCY_INQUIRY_THREADS_QUERY_KEY } from "@/features/inquiries/hooks/useGetAgencyInquiryThreads";

const useCreateOrderSheetSetInquiry = (orderSheetSetId?: number | null) => {
  const queryClient = useQueryClient();
  const identity = useIdentity();
  const { warning } = useAppToasts({ id: "GLOBAL" });
  const companyId = identity?.company?.id;
  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];

  const { mutate: createInquiry, isPending } = useMutation({
    mutationKey: [
      "order-sheet-set",
      "inquiries",
      "create",
      companyType,
      companyId,
      orderSheetSetId,
    ],
    mutationFn: (data: CreateOrderSheetSetInquiryRequest) =>
      orderHistoryApi.createOrderSheetSetInquiry(
        {
          companyType,
          companyId,
          orderSheetSetId: orderSheetSetId!,
        },
        data
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          "order-sheet-set",
          "inquiries",
          companyType,
          companyId,
          orderSheetSetId,
        ],
      });
      // 에이전시 문의함의 답변 필요·마지막 글이 바뀐다
      queryClient.invalidateQueries({
        queryKey: AGENCY_INQUIRY_THREADS_QUERY_KEY,
      });
    },
    onError: (err) => {
      const msg = (err as AxiosError<{ error?: { message?: string } }>)
        .response?.data?.error?.message;
      warning(msg ?? err.message);
    },
  });

  return { createInquiry, isPending };
};

export default useCreateOrderSheetSetInquiry;
